export default __webpack_public_path__ + "static/media/flotronixlogo.fe363b62.png";